<template>
    <v-container class="mt-8 pb-12" style="max-width: 1280px;">
        <div class="mb-4">
            <h1 class="text-h4 font-weight-bold mb-1">My Calendar</h1>
            <p class="text-subtitle-1 grey--text mb-0">
                Your leave &amp; work-from-home days for the year — click any open date to request one
            </p>
        </div>

        <v-skeleton-loader v-if="loading" type="card, article, article, article" />

        <v-card v-else-if="error" outlined class="pa-8 text-center">
            <v-icon size="48" color="grey lighten-1">mdi-calendar-alert</v-icon>
            <p class="grey--text mt-3 mb-4">Couldn't load your calendar.</p>
            <v-btn color="primary" outlined @click="load">Retry</v-btn>
        </v-card>

        <UserLeaveCalendar
            v-else
            page
            :user="get_user"
            :requests="requests"
            :balances="syntheticBalances"
            :leave-types="leaveTypes"
            :initial-year="currentYear"
            @add-request="openNewRequest"
        />

        <NewRequestDialog
            v-model="showNewRequest"
            :date="newRequestDate"
            :leave-types="leaveTypes"
            :users="approverList"
            :current-user="get_user"
            :role-managers="teamManagers"
            :roles="get_roles"
            @created="load"
        />
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import UserLeaveCalendar from '@/components/leave-management/UserLeaveCalendar.vue';
import NewRequestDialog from './NewRequestDialog.vue';

export default {
    name: 'MyCalendarComponent',
    components: { UserLeaveCalendar, NewRequestDialog },
    inject: { users: { default: null }, roleManagers: { default: null } },
    data() {
        return {
            loading: true,
            error: false,
            requests: [],
            credits: [],
            leaveTypes: [],
            currentYear: new Date().getFullYear(),
            showNewRequest: false,
            newRequestDate: null,
        };
    },
    computed: {
        ...mapGetters({ get_user: 'auth/get_user', get_roles: 'auth/get_roles' }),
        teamManagers() {
            return (this.roleManagers && this.roleManagers()) || [];
        },
        // UserLeaveCalendar looks up a balance record by user id and reads `get_leaves`.
        syntheticBalances() {
            return this.get_user ? [{ id: this.get_user.id, get_leaves: this.credits }] : [];
        },
        approverList() {
            return typeof this.users === 'function' ? this.users() : (this.users || []);
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.loading = true;
            this.error = false;
            try {
                const [reqRes, credRes, typeRes] = await Promise.all([
                    this.$axios.get('/api/leave'),
                    this.$axios.get('/api/leave/credits'),
                    this.$axios.get('/api/leave/type'),
                ]);
                this.requests = Array.isArray(reqRes.data) ? reqRes.data : [];
                this.credits = Array.isArray(credRes.data) ? credRes.data : [];
                this.leaveTypes = Array.isArray(typeRes.data) ? typeRes.data : [];
            } catch (e) {
                console.error('[MyCalendar] load error', e);
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
        openNewRequest(dateKey) {
            this.newRequestDate = dateKey;
            this.showNewRequest = true;
        },
    },
};
</script>
